export class LogitudeToken {
    Token: string | null;
    DocumentDownloadToken: string | null;
}